import { render, staticRenderFns } from "./HeaderNotice.vue?vue&type=template&id=0fe3866c&scoped=true&"
import script from "./HeaderNotice.vue?vue&type=script&lang=js&"
export * from "./HeaderNotice.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotice.vue?vue&type=style&index=0&id=0fe3866c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe3866c",
  null
  
)

export default component.exports